var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85742 5.28125H16.1431",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1322 5.28125H3.86477L3.79162 6.61039C3.65068 9.1561 3.77016 11.7095 4.14819 14.231C4.31277 15.3304 5.25791 16.1441 6.36991 16.1441H11.6293C12.7413 16.1441 13.6865 15.3304 13.8511 14.231C14.2282 11.7098 14.3482 9.15668 14.2076 6.61039L14.1345 5.28125H14.1322Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14453 5.28028V4.70999C6.14453 3.95344 6.44507 3.22788 6.98003 2.69292C7.51499 2.15796 8.24055 1.85742 8.9971 1.85742C9.75365 1.85742 10.4792 2.15796 11.0142 2.69292C11.5491 3.22788 11.8497 3.95344 11.8497 4.70999V5.28142",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28516 8.33594V13.0651V8.33594Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28516 8.33594V13.0651",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.709 8.33594V13.0651V8.33594Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.709 8.33594V13.0651",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4fb3d474b019bcd7b44c6f3bb41f7e00.svg";
export { ForwardRef as ReactComponent };